var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7529 9.59047L12.5862 8.75714C13.6908 7.65257 13.6908 5.86171 12.5862 4.75714C11.4817 3.65257 9.69081 3.65257 8.58624 4.75714L7.75291 5.59047M5.41957 7.9238L4.58624 8.75714C3.48167 9.86171 3.48167 11.6526 4.58624 12.7571C5.69081 13.8617 7.48167 13.8617 8.58624 12.7571L9.41957 11.9238M10.0862 7.25714L7.08624 10.2571",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.968482d9fb8e50634c00616e07ae31b8.svg";
export { ForwardRef as ReactComponent };